// @flow
import * as React from "react";
import cx from "classnames";

import ProgressBar, { type StepState } from "../../ProgressBar/ProgressBar";
import Header from "../shared/Header";

import styles from "./InquiryNavbar.scss";

import DbbLogo from "../../../assets/logos/DBB_Logo.svg";
import ScrollProvider from "../shared/ScrollProvider";
import type { ReactElementRef } from "../../../types/react";
import type { Logo } from "../shared/Header/Header";

type InquiryNavbarProps = {
  children: React.Node,
  logos: Logo[],
  activeStepId: string,
  steps: StepState[],
  customContainerStyles: string,
  isProgressBarVisible: boolean,
  customHeaderStyles: string,
  customLogoContainerStyles?: string,
  isNarrowHeader: boolean
};

const DEFAULT_LOGOS = [{ path: DbbLogo }];

type NavbarHeightContextType = ?() => number;

export const NavbarHeightContext = React.createContext<NavbarHeightContextType>(null);

class InquiryNavbar extends React.Component<InquiryNavbarProps> {
  navContainerRef: ReactElementRef<HTMLDivElement> = React.createRef();

  static defaultProps = {
    isProgressBarVisible: true,
    customContainerStyles: "",
    customLogoContainerStyles: "",
    isNarrowHeader: false
  };

  getHeaderHeight = () => {
    if (this.navContainerRef && this.navContainerRef.current) {
      return this.navContainerRef.current.offsetHeight;
    }

    return 0;
  };

  render() {
    const {
      children,
      activeStepId,
      steps,
      isProgressBarVisible,
      logos,
      customContainerStyles,
      customLogoContainerStyles,
      customHeaderStyles,
      isNarrowHeader
    } = this.props;

    return (
      <NavbarHeightContext.Provider value={this.getHeaderHeight}>
        <ScrollProvider>
          {({ isScrolledToTop }) => (
            <>
              <div className={styles.navContainer} ref={this.navContainerRef}>
                <Header
                  logos={logos || DEFAULT_LOGOS}
                  isScrolledToTop={isScrolledToTop}
                  type="inquiry"
                  customContainerStyles={styles.headerContainer}
                  customLogoStyles={styles.logo}
                  customHeaderStyles={customHeaderStyles}
                  customLogoContainerStyles={customLogoContainerStyles}
                  isNarrowHeader={isNarrowHeader}
                />
                {isProgressBarVisible && <ProgressBar activeStepId={activeStepId} steps={steps} />}
              </div>
              <div className={cx(styles.contentContainer, customContainerStyles)}>{children}</div>
            </>
          )}
        </ScrollProvider>
      </NavbarHeightContext.Provider>
    );
  }
}

export default InquiryNavbar;
